module.exports = __webpack_public_path__ + "img/list-pattern2.2d71bbf.svg";